module.exports = __webpack_public_path__ + "static/media/gallery_06_thumb.50fa4c12.jpg";